import React, { useEffect } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css"; // Import Quill styles
import { Form } from "@themesberg/react-bootstrap";

const TextEditor = ({
  Label,
  name,
  register,
  setValue,
  watch,
  errors,
  validationRules,
  preview = false,
}) => {
  const value = watch(name) || ""; // Get the current value from form state

  // Update the form state when the value changes
  const handleChange = (content) => {
    setValue(name, content, { shouldValidate: true }); // Update form state and trigger validation
  };

  // Register the field in useEffect to avoid uncontrolled input issues
  useEffect(() => {
    register(name, validationRules);
  }, [register, name, validationRules]);

  return (
    <>
      {Label && (
        <Form.Label>
          {Label}{" "}
          {validationRules?.required && <span style={{ color: "red" }}>*</span>}
        </Form.Label>
      )}
      <div className="quill-wrapper">
        <ReactQuill theme="snow" value={value} onChange={handleChange} />
      </div>

      {/* Display validation errors if any */}
      {errors[name] && (
        <div className="text-danger">{errors[name]?.message}</div>
      )}

      {/* Optional preview */}
      {preview && (
        <div>
          <p className="p-0 m-0 mt-3">
            <strong>Preview:</strong>
          </p>
          <div
            className="border p-2"
            dangerouslySetInnerHTML={{ __html: value }}
          ></div>
        </div>
      )}
    </>
  );
};

export default TextEditor;
